import { definitionNotHeld, HandBack, record, upper, type JanusCtx } from '../ability/context.js';
import { janus } from '../ability/janus.js';

export const TELEPORT_DISPLACEMENT_ID = '7A5F5C86-B457-462B-964F-33C5CFAF9BF7';

/** The same native damage dispatch as falling: mitigation, temporary vitality and life-state consequences stay shared. */
export function resolveTeleportDisplacementDamage(ctx: JanusCtx, actorId: string, dice: number): void {
  if (!(dice > 0)) return;
  actorId = upper(actorId);
  const victim = ctx.members.get(actorId);
  if (!victim) throw new HandBack('teleport:displacement-actor-not-held');
  const carrier = ctx.read.definition(TELEPORT_DISPLACEMENT_ID);
  if (!carrier) definitionNotHeld('teleport:displacement-definition-not-held', TELEPORT_DISPLACEMENT_ID);
  const damage = { ...carrier, item_layer_types: { ...record(carrier.item_layer_types), dice: 2 * dice, die: 10 } };
  const start = ctx.rows.length;
  janus(ctx, { abilityId: TELEPORT_DISPLACEMENT_ID, casterId: actorId, targetIds: [actorId], castingTargets: actorId,
    rawDiceMod: 0, rawDiceAdvDisStacks: 0, useAbilityVariable1: null, useAbilityVariable2: null }, damage, victim, [victim]);
  for (const row of ctx.rows.slice(start)) if (row.roll_item_id === TELEPORT_DISPLACEMENT_ID && row.dice?.die === 10) {
    // Retain the native roll faces and feedback; the cause belongs to this single damage row.
    row.rolls_full = [...(Array.isArray(row.rolls_full) ? row.rolls_full : []),
      [0, `Materialised inside solid: ${row.roll_result} force damage`]];
  }
}
